import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { requestMenuListAsync } from '../../api'

const menuSlice = createSlice({
  name: 'menu',
  initialState: [
    {
      id: 1,
      name: '欢迎进入',
      path: '/manage',
      icon: 'DashboardOutlined'
    }
  ],
  reducers: {
    getMenuList: (_, { payload }) => payload
  },
  extraReducers(builder) {
    builder.addCase(getMenuListAsync.fulfilled, (_, { payload }) => payload)
  }
})

export const { getMenuList } = menuSlice.actions

// 异步获取菜单
export const getMenuListAsync = createAsyncThunk('menu/getMenuListAsync', async () => {
  const payload = await requestMenuListAsync()
  if (payload) return payload
})

export default menuSlice.reducer